/* CRA product page redesign (Nov 2026). Markup: snippets/cra-pdp-head, cra-underlay, cra-pdp-promise,
 * cra-pdp-delivery. Warehouse 7.0.1 re-renders the product form from the server on every size change, so everything
 * here re-applies after `product:rerender` instead of holding element references.
 * 1. Estimated delivery dates: dispatch day (from the size's stock state) + the chosen area's transit days
 *    (Delivery Schedule page). Business days in Sydney time; national public holidays skipped. Area remembered.
 * 2. Add to cart shows the total, rug + the ticked underlay.
 * 3. "Details" / rating links scroll smoothly and open the Delivery & returns panel. */
(function () {
  if (window.craPdp) return;
  window.craPdp = true;

  // Transit business days after dispatch, read from the Delivery Schedule page (snippets/cra-delivery-areas.liquid).
  // No default area: only a third of orders are NSW.
  var AREAS = {}, REMOTE = '';
  try {
    JSON.parse((document.querySelector('[data-cra-areas]') || {}).textContent || '[]').forEach(function (a) {
      AREAS[a.key] = [a.min, a.max]; if (a.remote) REMOTE = a.key;
    });
  } catch (e) {}
  // NSW public holidays (dispatch is from Sydney). Update each December for the next year; after the last date the
  // estimate simply ignores holidays.
  var HOLIDAYS = ['2026-12-25', '2026-12-28', '2027-01-01', '2027-01-26', '2027-03-26', '2027-03-27', '2027-03-29', '2027-04-26',
    '2027-06-14', '2027-08-02', '2027-10-04', '2027-12-27', '2027-12-28'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var KEY = 'cra_area';

  function sydneyToday() {
    var p = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
    var get = function (t) { return +p.find(function (x) { return x.type === t; }).value; };
    return { date: new Date(Date.UTC(get('year'), get('month') - 1, get('day'))) };
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function isBusiness(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(iso(d)) < 0; }
  function addBusiness(d, n) { var x = new Date(d); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isBusiness(x)) n--; } return x; }
  function fmt(d, withMonth) {
    var s = d.toLocaleDateString('en-AU', { timeZone: 'UTC', weekday: 'short', day: 'numeric' });
    return withMonth ? s + ' ' + MONTHS[d.getUTCMonth()] : s;
  }
  function range(a, b) {
    var same = a.getUTCMonth() === b.getUTCMonth();
    return fmt(a, !same) + ' – ' + fmt(b, true);
  }
  function area() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }

  function eta(box) {
    var state = box.getAttribute('data-state'), due = box.getAttribute('data-due');
    if (state !== 'ship' && !(state === 'pre' && due)) return;
    if (/austex/i.test(box.getAttribute('data-vendor') || '')) return; // ships from Perth: no Sydney-based table
    var outs = box.querySelectorAll('[data-cra-eta]'), sel = box.querySelector('[data-cra-area]');
    if (!outs.length || !sel) return;
    var days = parseInt(box.getAttribute('data-days'), 10) || 1;
    var now = sydneyToday();
    var dispatch;
    if (state === 'pre') {                                            // pre-order: lands on the due date, ships the next business day
      var p = due.split('-'), landed = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
      dispatch = addBusiness(landed > now.date ? landed : now.date, 1);
    } else if (days <= 2) dispatch = addBusiness(now.date, days);   // "1 business day" / "within 2 days"
    else { dispatch = new Date(now.date); dispatch.setUTCDate(dispatch.getUTCDate() + days); while (!isBusiness(dispatch)) dispatch.setUTCDate(dispatch.getUTCDate() + 1); }
    var to = box.querySelector('[data-cra-to]'); if (to && to.hidden) to.hidden = false;
    var a = area();
    sel.value = AREAS[a] ? a : '';
    var chosen = !!AREAS[sel.value];
    var hint = box.querySelector('[data-cra-pick-hint]'), none = box.querySelector('[data-cra-noarea]');
    if (hint) hint.hidden = chosen;
    var lab = box.querySelector('[data-cra-to-label]'); if (lab) lab.hidden = !chosen;
    if (none) none.hidden = chosen;
    var choose = box.querySelector('[data-cra-choose]'); if (choose) choose.hidden = chosen;
    if (!chosen) { outs.forEach(function (o) { if (!o.hidden) o.hidden = true; }); return; }
    var t = AREAS[sel.value];
    var remote = box.querySelector('[data-cra-remote]'); if (remote) remote.hidden = sel.value !== REMOTE;
    set(box.querySelector('[data-cra-dates]'), range(addBusiness(dispatch, t[0]), addBusiness(dispatch, t[1])));
    outs.forEach(function (o) { if (o.hidden) o.hidden = false; });
  }

  function set(el, text) { if (el && el.textContent !== text) el.textContent = text; } // no-op writes keep the observer quiet
  function money(cents) {
    var v = cents / 100, whole = Math.round(v) === v;
    return '$' + v.toLocaleString('en-AU', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  }
  function qtyOf(form) {
    var q = form.querySelector('.cra-qty [name="quantity"]');           // not the theme's own (hidden) quantity field
    return Math.max(1, parseInt(q && q.value, 10) || 1);
  }
  function total(form) {
    var el = form && form.querySelector('[data-cra-total]');
    if (!el) return;
    var rug = parseInt(el.getAttribute('data-rug'), 10) || 0;
    var qty = qtyOf(form);
    var box = document.querySelector('[data-cra-underlay][data-form-id="' + form.getAttribute('id') + '"]');
    var pick = box && box.querySelector('input[type="radio"]:checked');
    var pad = pick && pick.value ? parseInt(pick.getAttribute('data-price'), 10) || 0 : 0;
    set(el, ' · ' + money((rug + pad) * qty));
    var note = form.parentNode.querySelector('[data-cra-total-note]') || form.querySelector('[data-cra-total-note]');
    if (note) {
      var x = qty > 1 ? qty + ' × ' : '';
      set(note, pad ? (x ? x + 'rug ' : 'Rug ') + money(rug) + ' + ' + x + 'underlay ' + money(pad) : '');
      if (note.hidden !== !pad) note.hidden = !pad;
    }
  }

  // R3: Afterpay's wordmark in black on white so it sits beside Shop Pay's wordmark as an equal (was the mint pill)
  function bnplLook() {
    document.querySelectorAll('.cra-head square-placement').forEach(function (p) {
      if (p.getAttribute('data-badge-theme') !== 'black-on-white') p.setAttribute('data-badge-theme', 'black-on-white');
    });
  }
  function refresh() {
    bnplLook();
    document.querySelectorAll('[data-cra-promise]').forEach(eta);
    document.querySelectorAll('form[id^="product-form-main"]').forEach(total);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-cra-area]')) {
      try { localStorage.setItem(KEY, t.value); } catch (err) {}
      refresh();
    } else if (t.matches && t.matches('[name="quantity"]') && t.form) {
      total(t.form);
    } else if (t.closest && t.closest('[data-cra-underlay]')) {
      var id = t.closest('[data-cra-underlay]').getAttribute('data-form-id');
      total(document.getElementById(id));
    }
  });

  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('[name="quantity"]') && e.target.form) total(e.target.form); });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.cra-qty')) setTimeout(function () { var f = e.target.closest('form'); if (f) total(f); }, 0);
    var a = e.target.closest && e.target.closest('[data-cra-scroll], [data-cra-open]');
    if (!a) return;
    var id = a.getAttribute('data-cra-open') || (a.getAttribute('href') || '').replace('#', '');
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    if (target.tagName === 'DETAILS') target.open = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* Opening size (R2): a link with ?variant= wins. Else ?size= (carried over from a colour swatch) if that size
   * exists here, else the first size that can ship now when the default one can't (pre-order, made to order, sold
   * out). Selecting goes through 7.0.1's own <variant-picker> change, so the page, URL and Shop Pay stay in step. */
  function pick(input) { if (!input || input.checked) return; input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
  function openingSize() {
    var form = document.querySelector('form[id^="product-form-main"]');
    var picker = form && document.querySelector('variant-picker[form-id="' + form.getAttribute('id') + '"]');
    if (!picker) return;
    var q = new URLSearchParams(location.search);
    if (q.get('variant')) return;
    var radios = Array.prototype.slice.call(picker.querySelectorAll('input.block-swatch__radio'));
    if (!radios.length) return;
    var labelOf = function (r) { return picker.querySelector('label[for="' + r.id + '"]'); };
    var want = (q.get('size') || '').toLowerCase().replace(/\s/g, '');
    if (want) {
      var hit = radios.filter(function (r) { var l = labelOf(r); return l && (l.getAttribute('title') || '').toLowerCase().replace(/\s/g, '') === want; })[0];
      if (hit) return pick(hit);
    }
    var ships = function (r) { var l = labelOf(r); return l && l.querySelector('.cra-size-sub--ship'); };
    var cur = radios.filter(function (r) { return r.checked; })[0];
    if (cur && ships(cur)) return;
    pick(radios.filter(ships)[0]);
  }
  // Reviews: "Show all N reviews" reveals the rest of the natively drawn list (snippets/cra-pdp-reviews.liquid)
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cra-more-reviews]');
    if (!b) return;
    var box = b.closest('.cra-reviews');
    box.querySelectorAll('.cra-review--more').forEach(function (li) { li.hidden = false; });
    b.parentNode.hidden = true;
  });

  // "Why an underlay?" sheet (snippets/cra-pad-why.liquid)
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-cra-pad-why]');
    var d = document.getElementById('cra-pad-why');
    if (open && d && d.showModal) { e.preventDefault(); d.showModal(); return; }
    if (d && d.open && (e.target === d || (e.target.closest && e.target.closest('[data-cra-sheet-close]')))) d.close();
  });

  document.addEventListener('click', function (e) {                   // colour swatch: take the chosen size along
    var a = e.target.closest && e.target.closest('.cra-colour-siblings a[href]');
    if (!a) return;
    var sel = document.querySelector('form[id^="product-form-main"]') && document.querySelector('variant-picker input.block-swatch__radio:checked');
    var lab = sel && document.querySelector('label[for="' + sel.id + '"]');
    if (!lab) return;
    var u = new URL(a.href, location.href); u.searchParams.delete('variant'); u.searchParams.set('size', lab.getAttribute('title'));
    a.href = u.pathname + u.search;
  }, true);

  // 7.0.1 swaps the form's HTML after product:rerender fires, so re-apply once the new nodes are in.
  var queued = false;
  function soon() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; refresh(); }); }
  function watch() {
    document.querySelectorAll('product-rerender').forEach(function (el) {
      if (el.craWatched) return; el.craWatched = true;
      new MutationObserver(soon).observe(el, { childList: true, subtree: true });
    });
  }
  // Capture phase, before the swap: carry the chosen quantity into the new HTML (7.0.1 only keeps quantity inside the
  // variant-selector block; ours sits beside the button).
  document.addEventListener('product:rerender', function (e) {
    var frag = e.detail && e.detail.htmlFragment, t = e.target;
    var form = t && t.matches && t.matches('form') ? t : (t && t.querySelector ? t.querySelector('form[id^="product-form-main"]') : null);
    var live = form && form.querySelector('.cra-qty [name="quantity"]');
    var next = frag && frag.querySelector('.cra-qty [name="quantity"]');
    if (live && next && live.value !== '1') { next.value = live.value; next.setAttribute('value', live.value); }
  }, true);
  document.addEventListener('product:rerender', function () { setTimeout(refresh, 0); setTimeout(refresh, 400); });
  function boot() { watch(); openingSize(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();

  // R5 (Alex): previous/next arrows on the main photo. Desktop: they fade in while the mouse is over the photo.
  // Phones/tablets (no hover): small and always shown. They step through the visible thumbnails, so the theme's own
  // gallery (Flickity, zoom, selected thumbnail, colour filtering) does the work exactly as for a thumbnail click.
  function craArrows() {
    var wrap = document.querySelector('[data-section-type="product"] .product-gallery__carousel-wrapper');
    if (!wrap || wrap.querySelector('.cra-gal-arrow')) return;
    var thumbs = function () { return Array.prototype.filter.call(wrap.closest('.product-gallery').querySelectorAll('.product-gallery__thumbnail'), function (t) { return !t.classList.contains('is-filtered'); }); };
    if (thumbs().length < 2) return;
    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cra-gal-arrow cra-gal-arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous photo' : 'Next photo');
      b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var list = thumbs(); if (list.length < 2) return;
        var i = list.findIndex(function (t) { return t.classList.contains('is-nav-selected'); });
        var n = (i + (dir === 'prev' ? -1 : 1) + list.length) % list.length;
        list[n].click();
      });
      wrap.appendChild(b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', craArrows); else craArrows();
})();
